import { runtimeConfig } from './runtime-config';

export const MEZIA_THEME_ENABLED = true;

const domain = runtimeConfig.domain as string;

export const isMezia = domain === 'mezia.co.il' || domain.endsWith('.mezia.co.il');

export const isDoskaIsrael = domain === 'doskatv.co.il' || domain.endsWith('.doskatv.co.il');

export const meziaTheme = isMezia && MEZIA_THEME_ENABLED;

export const brand = meziaTheme ? 'mezia' : undefined;
